import { sanitizedRedirectWindow } from '#pplx/frontend/common/sanitizedRedirectWindow.js';
export function redirectToSignInError() {
    sanitizedRedirectWindow('/auth/error');
}
//# sourceMappingURL=utils.js.map